export default __webpack_public_path__ + "static/media/Gum 2.4a8f19e7.png";